import { render, staticRenderFns } from "./OrdersToPack.vue?vue&type=template&id=4779f30e&"
import script from "./OrdersToPack.vue?vue&type=script&lang=js&"
export * from "./OrdersToPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports